import { useEffect, useState } from "react";

export default function Modal({ isOpen, onClose, title = "Perfil", children, closeActive = true }) {
  const [isClicked, setIsClicked] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden"; 
    const onEsc = (e) => e.key === "Escape" && closeActive && onClose?.();
    window.addEventListener("keydown", onEsc);
    return () => {
      document.body.style.overflow = prev;
      window.removeEventListener("keydown", onEsc);
    };
  }, [isOpen, onClose, closeActive]);

  if (!isOpen) return null;

  const handleBackdrop = (e) => {
    if (e.target === e.currentTarget && closeActive) onClose?.();
  };

  const closeValid = () => {
    setIsClicked(true);
    setTimeout(() => {
      if(closeActive) onClose?.();
      setIsClicked(false);
    }, 200);
  }

  return (
    <div
      className="fixed inset-0 z-50 bg-black/50 flex items-center justify-center p-4"
      onMouseDown={handleBackdrop}
      role="dialog"
      aria-modal="true"
      aria-labelledby="modal-title"
    >
      <div className="bg-white w-full max-w-4xl max-h-[85vh] shadow-xl flex flex-col">
        <div className="sticky top-0 z-10 bg-white border-b px-5 py-3 flex items-center justify-between">
          <h2 id="modal-title" className="text-lg font-semibold">{title}</h2>
          <button
            type="button" onClick={closeValid}
            className={`group absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full
             text-gray-500  active:bg-gray-200 focus:outline-none
             focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2
             focus-visible:ring-offset-white transition dark:text-gray-400  dark:focus-visible:ring-offset-personalized
             ${closeActive ? "hover:text-gray-700 hover:bg-gray-100 dark:hover:text-gray-200 dark:hover:bg-personalized" : " cursor-not-allowed"}
             close-btn ${isClicked ? 'clicked' : ''}`}
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"
            >
              <path d="M6 6l12 12M18 6L6 18" />
            </svg>
            <span className="sr-only">Cerrar</span>
          </button>
        </div>
        <div className="overflow-y-auto [&>*:first-child]:mt-0 [&>*:last-child]:mb-0">
          {typeof children === 'function' ? children(closeValid) : children}
        </div>
      </div>
    </div>
  );
}
